export enum ConversationTypeEnum {
  Client = 'CLIENT',
  Prospect = 'PROSPECT',
}
